export default __webpack_public_path__ + "static/service-mesh-93212b9838143906057016a555b2d4d4.mp4";